import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import { colors } from "UI/colors";

import useComponentIsMounted from "Utilities/Hooks/useComponentIsMounted";

import UnlinkFromGroup from "./UnlinkFromGroup";

export default function LinkedToGroupNotification({
  name,
  photoURL,
  shortname,
  signupItemID,
}) {
  const isMounted = useComponentIsMounted();

  return (
    <AnimatePresence>
      {shortname && (
        <Wrapper
          initial={isMounted ? { height: 0, opacity: 0 } : null}
          animate={{ height: "auto", opacity: 1 }}
          exit={{
            height: "auto",
            opacity: 1,
            transition: { type: "tween", duration: 0.2 },
          }}
        >
          <Icon bgImage={photoURL} />
          <Text>
            <LinkedTitle>Linked to {name}</LinkedTitle>
            <HelpText>{`When people sign up for this item, they'll automatically be added to the ${name} group.`}</HelpText>
          </Text>
          <UnlinkFromGroup signupItemID={signupItemID} />
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  border: 1px solid ${colors.fnGray200};
  background: #fff;
  border-radius: 8px;
  margin-bottom: 6px;
  padding: 12px;
  box-shadow: rgba(0, 0, 0, 0.2) inset 0 1px 4px;
  display: flex;
  align-items: center;
`;
const Icon = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  background-size: cover;
  background-color: #fff;
  background-position: center center;
  background-image: url(${({ bgImage }) => bgImage});
  box-shadow: rgba(0, 0, 0, 0.3) 1px 1px 4px;
  border-radius: 32px;
  margin-right: 12px;
`;
const Text = styled.div`
  flex-grow: 1;
  margin-right: 12px;
`;
const LinkedTitle = styled.div`
  font-weight: 400;
`;
const HelpText = styled.div`
  margin-top: 2px;
  font-size: 13px;
  font-weight: 400;
  color: #828c8d;
  line-height: 16px;
`;
